var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: {
        female: _vm.person.Sex
          ? _vm.person.Sex !== null && _vm.person.Sex.indexOf("女") !== -1
          : null,
        ban: _vm.person.BlacklistReason,
      },
    },
    [
      _c(
        "div",
        { staticClass: "card-inner", staticStyle: { position: "relative" } },
        [
          _c("div", { staticClass: "basic-info" }, [
            _c(
              "div",
              { staticClass: "img-wrap" },
              [
                [
                  _vm.person.BlacklistReason
                    ? _c(
                        "el-tooltip",
                        {
                          staticClass: "item",
                          attrs: {
                            effect: "light",
                            content: _vm.person.BlacklistReason,
                            placement: "top",
                          },
                        },
                        [
                          _c("el-image", {
                            attrs: {
                              src:
                                _vm.person.HeadPhotoBase64 === null
                                  ? require(`@/assets/img/head2.png`)
                                  : _vm.person.HeadPhotoBase64,
                              "preview-src-list":
                                _vm.person.HeadPhotoBase64 === null
                                  ? null
                                  : [_vm.person.HeadPhotoBase64],
                              alt: "大頭照",
                            },
                          }),
                        ],
                        1
                      )
                    : _c("el-image", {
                        attrs: {
                          src:
                            _vm.person.HeadPhotoBase64 === null
                              ? require(`@/assets/img/head2.png`)
                              : _vm.person.HeadPhotoBase64,
                          "preview-src-list":
                            _vm.person.HeadPhotoBase64 === null
                              ? null
                              : [_vm.person.HeadPhotoBase64],
                          alt: "大頭照",
                        },
                      }),
                ],
              ],
              2
            ),
            _c(
              "div",
              { staticClass: "info" },
              [
                _vm._t("tag", null, { props: _vm.person }),
                _c(
                  "div",
                  { staticClass: "note" },
                  [_vm._t("note", null, { props: _vm.person })],
                  2
                ),
                _c(
                  "div",
                  { staticClass: "name" },
                  [
                    _vm._v(" " + _vm._s(_vm.person.Name) + " "),
                    _vm.person.Age
                      ? [
                          _vm.person.Age !== 121
                            ? _c("span", { staticClass: "age" }, [
                                _vm._v(" " + _vm._s(_vm.person.Age) + " 歲 "),
                              ])
                            : _vm._e(),
                        ]
                      : _vm._e(),
                  ],
                  2
                ),
                _c("div", { staticClass: "email" }, [
                  _vm._v(_vm._s(_vm.person.Email)),
                ]),
              ],
              2
            ),
          ]),
          _vm.showCheckbox
            ? _c("label", { staticClass: "check-wrap" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.person.isChecked,
                      expression: "person.isChecked",
                    },
                  ],
                  attrs: { type: "checkbox" },
                  domProps: {
                    checked: _vm.person.isChecked,
                    checked: Array.isArray(_vm.person.isChecked)
                      ? _vm._i(_vm.person.isChecked, null) > -1
                      : _vm.person.isChecked,
                  },
                  on: {
                    click: function ($event) {
                      return _vm.clickCheck(_vm.person)
                    },
                    change: function ($event) {
                      var $$a = _vm.person.isChecked,
                        $$el = $event.target,
                        $$c = $$el.checked ? true : false
                      if (Array.isArray($$a)) {
                        var $$v = null,
                          $$i = _vm._i($$a, $$v)
                        if ($$el.checked) {
                          $$i < 0 &&
                            _vm.$set(_vm.person, "isChecked", $$a.concat([$$v]))
                        } else {
                          $$i > -1 &&
                            _vm.$set(
                              _vm.person,
                              "isChecked",
                              $$a.slice(0, $$i).concat($$a.slice($$i + 1))
                            )
                        }
                      } else {
                        _vm.$set(_vm.person, "isChecked", $$c)
                      }
                    },
                  },
                }),
                _vm._m(0),
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "detail-info" },
            [_vm._t("middleContent", null, { props: _vm.person })],
            2
          ),
          _c(
            "div",
            { staticClass: "file-info" },
            [_vm._t("buttonGroup", null, { props: _vm.person })],
            2
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", [_c("i", { staticClass: "fas fa-check" })])
  },
]
render._withStripped = true

export { render, staticRenderFns }